<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <h1 class="site-page__title">意见反馈</h1>
      <div class="site-page__card">
        <el-form
          ref="feedbackForm"
          :model="feedbackForm"
          :rules="rules"
          label-position="top"
          class="site-page__form"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="feedbackForm.name" placeholder="您的姓名" />
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input v-model="feedbackForm.email" placeholder="您的邮箱" />
          </el-form-item>

          <el-form-item label="反馈类型" prop="type">
            <el-select v-model="feedbackForm.type" placeholder="请选择类型" style="width: 100%">
              <el-option label="建议" value="suggestion" />
              <el-option label="问题反馈" value="bug" />
              <el-option label="功能需求" value="feature" />
              <el-option label="其他" value="other" />
            </el-select>
          </el-form-item>

          <el-form-item label="详细说明" prop="message">
            <el-input
              v-model="feedbackForm.message"
              type="textarea"
              :rows="6"
              placeholder="请描述您的反馈内容"
            />
          </el-form-item>

          <el-form-item>
            <div class="site-page__form-actions">
              <el-button type="primary" @click="submitForm">提交反馈</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackView',
  data() {
    return {
      feedbackForm: {
        name: '',
        email: '',
        type: '',
        message: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        type: [{ required: true, message: '请选择反馈类型', trigger: 'change' }],
        message: [{ required: true, message: '请输入反馈内容', trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.feedbackForm.validate((valid) => {
        if (valid) {
          this.$message.success('感谢您的反馈！')
          this.resetForm()
        }
      })
    },
    resetForm() {
      this.$refs.feedbackForm.resetFields()
    }
  }
}
</script>
